import React, { SVGProps } from "react";

export const BoatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 128 128"
    {...props}
  >
    <path
      fill="#455a64"
      d="M109.76 96.85c1.45-.71 3.87-2.21 7.52-2.06 4.78.2 6.58 1.88 7.15 2.93.56 1.05.32 7.89-.66 9.45-.99 1.56-3.86 6.1-3.86 6.1l3.71 2.12c.23.13.37.39.35.67l-.11 1.9c-.02.39-.35.69-.73.67l-3.21-.19-.1 6.88c-.01.42-.46.66-.79.43l-5.21-3.66a.52.52 0 0 1-.22-.42l-.23-9.34-2.64-.65c-.02 0-2.42-14.12-.97-14.83z"
    />
    <path
      fill="#546e7a"
      d="M123.54 98.48c.32-.29.54-.67.67-1.09-.75-1.04-2.63-2.42-6.93-2.59-3.65-.15-6.06 1.35-7.52 2.06-.17.08-.3.29-.4.58.03.04.04.08.07.12.56.81 1.27 1.15 2.24 1.1.98-.06 1.94-.35 2.93-.42 1.06-.08 2.12-.02 3.16.17.26.05.51.1.77.16.85.21 1.68.51 2.55.59.87.07 1.81-.09 2.46-.68z"
    />
    <path
      fill="none"
      stroke="#94d1e0"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m65.23 58.22-.43 7.67M71.56 58.62 71.14 66M57.57 65.8l.27-4.74c.1-1.82 1.34-3.22 2.76-3.13l19.54 1.23"
    />
    <path fill="#c9e3e6" d="m42.59 86.39 27.9 2.87V65.87H56.48z" />
    <path
      fill="#94d1e0"
      d="M92.55 72.92s3.28.17 5.17-1.23 1.56-3.57.93-3.63l-28.16-2.2L58.86 84.9l-15.18-.13-1.09 1.62 57.09 7.48-7.13-20.95z"
    />
    <path fill="#82aec0" d="M56.48 69.3h8.32l-7.24 12.12h-8.37z" />
    <path
      fill="#2f7889"
      d="m78.17 71.05-4.92-.42c-.67-.07-1.33.31-1.72 1.01l-4.89 8.93c-.41.76.22 1.66 1.07 1.52l10.41-1.68.05-9.36zM80.17 71.22l-.04 8.86 7.97-1.29c.95-.15 1.65-.97 1.65-1.93v-4.82l-9.58-.82z"
    />
    <path
      fill="none"
      stroke="#94d1e0"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M35.96 79.98 4.73 76.42M7.08 76.89c-.37 2.4-.36 5.45.38 7.71M31.84 79.51c-.2 2.54.18 4.87 1 6.88M19.67 78.13c0 1.99.34 4.81 1.34 7.07"
    />
    <path
      fill="#c9e3e6"
      d="m112.26 109.44-2.17-15.49a.5.5 0 0 0-.4-.41C41.8 83.56 6.59 83.81 6.59 83.81c-.44-.06-.78.51-.6 1.03 1.41 4.22 5.91 11.83 12.78 19.9 9.94 11.68 17.58 13.97 32.81 15.24l56.22-.22 3.45-3.74 2.93-.06c1.17-.02 2.15-1.21 2.24-2.72l.04-.66c.09-1.57-.82-2.9-2.04-2.99l-2.16-.15z"
    />
    <path
      fill="#82aec0"
      d="M43.98 114.21c-12.23-1.09-17.1-1.6-17.1-1.6 5.84 5.32 13.66 7.38 24.68 7.38l56.22-.22 1.19-1.29.87-1.15c-2.29-.9-54.6-2.11-65.86-3.12z"
    />
    <path
      fill="#1565c0"
      d="M110.71 98.29C57.57 92.01 9.13 91.4 9.13 91.4L6.7 86.72s49.77 2.09 103.65 9.16l.36 2.41z"
    />
    <path
      fill="#f44336"
      d="M111.32 102.75c-46.11-5.11-97.46-4.31-97.46-4.31l-3.21-4.57s41.79.91 100.31 6.33l.36 2.55z"
    />
  </svg>
);
